import React, { Component } from 'react'
import { observer } from 'mobx-react'
import styles from './style.module.less'
import mainStore from '@components/Main/store'
import { ctrlTextLen } from '@hlj/hlj-utils'
import Panel from '@common/Panel'
import _get from 'lodash/get'
import auth, { SYSTEM_NOTICE } from '../auth'
import { Link } from 'react-router'

/** 系统公告 */
@auth(SYSTEM_NOTICE)
@observer
export default class extends Component {
  render() {
    const notice = _get(mainStore, 'shopInfo.system_notice', [])[0]
    const { id, begin_at, title, is_new } = notice || {}
    return (
      !!notice && (
        <Panel
          title="系统公告"
          action={<a href="#/localMerchant/systemBulletin">更多</a>}
          contentStyle={{ padding: 0 }}
        >
          <Link to={`/localMerchant/systemBulletin/${id}`}>
            <div className={styles.content}>
              <div className={styles.noteText}>
                <span>{ctrlTextLen(title, 35, '...')}</span>
                {is_new !== 1 && (
                  <img
                    src="//qnm.hunliji.com/o_1cnqaj20l29rtgc9s6hih1ub39.png"
                    style={{ width: 36, height: 16 }}
                  />
                )}
              </div>
              <div className={styles.bottom}>
                <div className={styles.date}>
                  {(begin_at || '').split(' ')[0]}
                </div>
                <div className={styles.toDetail}>公告详情</div>
              </div>
            </div>
          </Link>
        </Panel>
      )
    )
  }
}
